import { PasswordRecoveryChangeResponse } from '../Messages/PasswordRecoveryChangeResponse';
import { MessageProcessorBase } from './MessageProcessorBase';
export class PasswordRecoveryChangeMessageProcessor extends MessageProcessorBase {
    decode(fieldSet) {
        const message = new PasswordRecoveryChangeResponse(fieldSet);
        return [message];
    }
}
